import axios from 'axios'

export const MAX_INDEX_CEREMONIES = 25

function endpoint(path = '') {
  return `${process.env.VUE_APP_BASE_URL || ''}/semantic-search/index-jobs${path}`
}

export function startCeremonyIndexing(ceremonyIds) {
  const ids = [...new Set((ceremonyIds || []).map(value => String(value)))]
  const payload = ids.length === 1
    ? { ceremony_id: ids[0] }
    : { ceremony_ids: ids }
  return axios.post(endpoint(), payload, { timeout: 30000 })
}

export function getCeremonyIndexingStatus(ceremonyId) {
  return axios.get(endpoint(`/${ceremonyId}`), { timeout: 10000 })
}
